export default {
    cargos: [],
    cargo: {}
}